<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <ToggleMenuBar
              v-model="state.menu"
              :first-menu="EMOTICON_MENU.MEMORIAL"
              :second-menu="EMOTICON_MENU.WATCH"
            />

            <EmoticonCard
              :items="FUNERAL_BUY_LIST"
              :selected="state.index"
              :menu="state.menu"
              :is-notice="true"
              v-if="state.menu === EMOTICON_MENU.MEMORIAL"
              @click="fnEmojiPick"
            />

            <EmoticonCard
              :items="FUNERAL_EMOTICON_LIST"
              :selected="state.index"
              :menu="state.menu"
              :is-notice="true"
              v-if="state.menu === EMOTICON_MENU.WATCH"
              @click="fnEmojiPick"
            />
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray" @click="close">닫기</button>
              <button class="btn" @click="fnFetch" v-if="state.menu === EMOTICON_MENU.MEMORIAL">선택</button>
              <button class="btn" @click="fnEmojiBuy" v-if="state.menu === EMOTICON_MENU.WATCH">선택</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, onBeforeMount, reactive, watch } from 'vue';
import { EMOTICON_MENU, FUNERAL_BUY_LIST, FUNERAL_EMOTICON_LIST } from '@/common/constants/ConstCode';
import { purchaseCall } from '@/common/utils/module/NativeRequest';
import store from '@/store';
import { modalList, show, showDoneModal } from '@/common/utils/ModalState';
import EmoticonCard from '@/components/common/funeral/EmoticonCard.vue';
import ToggleMenuBar from '@/components/common/layouts/ToggleMenuBar.vue';
import { isApp } from '@/common/utils/module/IsMobileSupport';
import { useRoute } from 'vue-router';
import { fnShowIsAppPurchaseModalDynamic, pointPurchase } from '@/common/utils/Util';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, funeralNo } = props.data;
const { params } = useRoute();

const user = computed(() => store.getters['user/getUserData']);

onBeforeMount(async () => {
  fnEmojiPick(FUNERAL_BUY_LIST?.value[0]);
});

const state = reactive({
  emoticon: '',
  funeralNo: funeralNo,
  emoticonNo: '',
  index: 0,
  menu: EMOTICON_MENU.MEMORIAL,
  list: FUNERAL_BUY_LIST
});
watch(
  () => state.menu,
  newValue => {
    newValue === EMOTICON_MENU.WATCH
      ? fnEmojiPick(FUNERAL_EMOTICON_LIST?.value[0])
      : fnEmojiPick(FUNERAL_BUY_LIST?.value[0]);
  }
);

const fnEmojiPick = (item, index = 0) => {
  state.emoticon = item?.file?.storedFileName;
  state.emoticonNo = item?.productNo;
  state.index = index;
};

const fnEmojiBuy = async () => {
  store.commit('user/setPurchase', '');
  // const point = await store.dispatch('premium/getPoint');

  show(modalList.CONFIRM, {
    contents: '해당 이모티콘을 구매하시겠습니까?',
    doneText: '구매',
    cancelText: '취소',
    doneCallback: async () => {
      const result = FUNERAL_EMOTICON_LIST.value.filter(emoticon => emoticon.productNo === state.emoticonNo);
      const purchase = {
        price: result[0].price,
        productCode: result[0].productCode,
        category: 'EMOTICON',
        productNo: state.emoticonNo,
        useTargetNo: state.funeralNo,
        productId: result[0].productId,
        name: result[0].name
      };
      store.commit('user/setPurchase', purchase);
      store.commit('user/setPurchaseCallBack', purchaseCallBack);
      // if (user.value.isPremium) {
      //   show(modalList.SUB_CONFIRM, {
      //     contents: `이용을 위해 ${purchase.price}포인트가 사용됩니다.\n 구매하시겠습니까?`,
      //     doneText: '확인',
      //     cancelText: '취소',
      //     doneCallback: async () => {
      //       if (point >= purchase.price) {
      //         await pointPurchase();
      //       } else {
      //         setTimeout(() => {
      //           showDoneModal('포인트가 부족합니다 \n 앱내 결제를 이용하여 구매하시겠습니까?', '확인', '취소', () => {
      //             inAppPurchase(purchase);
      //           });
      //         }, 100);
      //       }
      //     }
      //   });
      // } else {
      inAppPurchase(purchase);
      // }
    }
  });
};

const inAppPurchase = purchase => {
  if (isApp()) {
    purchaseCall(purchase.productId);
  } else {
    setTimeout(() => {
      fnShowIsAppPurchaseModalDynamic();
    }, 100);
  }
};

const purchaseCallBack = async () => {
  await store.dispatch('emoticon/buyEmoticon', state);
  await store.dispatch('emoticon/getEmoticonList', params.no);
  fnEmojiPick(FUNERAL_EMOTICON_LIST?.value[0]);
};
const fnFetch = () => {
  if (fnCallBack) fnCallBack(state);

  setTimeout(() => {
    emits('close');
  }, 200);
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
